import ModelBase from "./shared/model-base.js";
import type { SectionAttributes } from "./site-page-section";

interface ModelAttributes {
  id: string | number;
  page_type?: string;
  title?: string;
  variant?: string;
  seo?: Record<string, any>;
  position?: number;
  state?: string;
  page_type_text?: string;
  sections?: SectionAttributes[];
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "site_page",
  columns: [
    "id",
    "page_type",
    "title",
    "variant",
    "seo",
    "position",
    "state",
    "page_type_text",
    "sections",
    "created_at",
  ],
  editColumns: {},
};

export default class SitePage extends ModelBase {
  declare id: string | number;
  declare page_type: string;
  declare title: string;
  declare variant: string;
  declare seo: Record<string, any>;
  declare position: number;
  declare state: string;
  declare page_type_text: string;
  declare sections: SectionAttributes[];
  declare created_at: string;
  declare updated_at: string;

  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
